<div class="row">
  <app-form-text-edit id="recaptacio-num" class="col-xl-3" i18n-label label="Num. rebut" [(value)]="data.numRecibo" [isReadOnly]="this.isReadOnly"></app-form-text-edit>
</div>
